export enum Role {
  Clubadmin = "Clubadmin",
  Gymnast = "Gymnast",
  CompetitionOrganizer = "CompetitionOrganizer",
  ContactAdmin = "ContactAdmin",
}
